import React, { useRef, useState } from "react";
import MapLayer from "./MapLayer";
import useOutsideClick from "../../Helpers/OutsideClick/useOutsideClick";

export default function MapsLayers({ handlelayers }) {
  const offline = "https://tiles.softsprint.ae/tiles/{z}/{x}/{y}.png";
  const googlemap =
    "https://mt0.google.com/vt/lyrs=m,&hl=en&x={x}&y={y}&z={z}&s=Ga";
  const osm = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
  const satellite =
    "https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}&s=Ga";

  const [menu, setMenu] = useState(false);
  const [selected, setSelected] = useState(osm);
  const [selectedmap, setSelectedMap] = useState("OSM");

  const handleMenu = () => {
    setMenu(!menu);
  };

  const handleLayerSelect = (layer, mapName) => {
    setSelected(layer);
    setSelectedMap(mapName);
    handlelayers(layer); // Pass selected tile layer URL to parent
  };

  const menuRef = useRef(null);
  useOutsideClick(menuRef, () => setMenu(false), "click");

  return (
    <>
      <div
        role="button"
        className="map-tiles"
        ref={menuRef}
        onClick={handleMenu}
      >
        <div className="flex-between">
          <p>{selectedmap}</p>
          <div className="y-40">
            <img
              src={menu ? `${process.env.PUBLIC_URL}/assets/chevron-down.svg` : `${process.env.PUBLIC_URL}/assets/chevron-up.svg`}
              alt=""
            />
          </div>
        </div>
      </div>

      {menu && (
        <div role="button" className="map-tiles-menu">
          <MapLayer
            maplayer={osm}
            mapname="OSM"
            selected={selected}
            handleLayerSelect={handleLayerSelect}
            setSelectedMap={setSelectedMap}
          />
          <MapLayer
            maplayer={googlemap}
            mapname="Google"
            selected={selected}
            handleLayerSelect={handleLayerSelect}
            setSelectedMap={setSelectedMap}
          />
          <MapLayer
            maplayer={satellite}
            mapname="Satellite"
            selected={selected}
            handleLayerSelect={handleLayerSelect}
            setSelectedMap={setSelectedMap}
          />
          <MapLayer
            maplayer={offline}
            mapname="Offline"
            selected={selected}
            handleLayerSelect={handleLayerSelect}
            setSelectedMap={setSelectedMap}
          />
        </div>
      )}
    </>
  );
}
